var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    "aria-hidden": "true",
    width: "32px",
    height: "32px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bannerinfo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component-banner-warning",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FBBA20",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.999,20.513 L16.1622517,20.5138837 C15.7207506,16.9359199 15.5,12.7646253 15.5,8 L15.5,8 L18,8 L17.999,20.513 Z M18.0147929,23.0240652 C19.5236686,23.0240652 20.5,24.0014809 20.5,25.5416512 C20.5,27.0522029 19.5532544,28 17.9852071,28 C16.4763314,28 15.5,27.0522029 15.5,25.5120326 C15.5,23.9718623 16.5059172,23.0240652 18.0147929,23.0240652 Z M20.5,8 C20.5,12.7646253 20.2792494,16.9359199 19.8377483,20.5138837 L17.999,20.513 L18,8 L20.5,8 Z",
    id: "bannerWarning",
    fill: "#333333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerWarning);
export default __webpack_public_path__ + "static/media/bannerWarning.a5d7937479f0985bb87edc336d433e65.svg";
export { ForwardRef as ReactComponent };